import "@/front/plugins/packeta/packeta";

document.addEventListener("DOMContentLoaded", () => {
	initAddToCartForm();

	$(".form-cart-data-submit").off("click").on("click", function (e) {
		$("input[type=\"submit\"][name=\"send\"]").click();
		e.preventDefault();
		e.stopPropagation();
	});

	$(".delivery-option").off("click").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

		$(".delivery-option").removeClass("selected");
		$(this).addClass("selected");
		$(this).find("input").prop("checked", true);

		$(".payment-option").removeClass("selected").addClass("d-none");
		$(".payment-option input[type=\"radio\"]").prop("checked", false);

		const acceptablePaymentIds = $(this).data("payment-ids");

		for (let acceptablePaymentId in acceptablePaymentIds) {
			if (acceptablePaymentIds.hasOwnProperty(acceptablePaymentId)) {
				const paymentOption = $("[data-payment-id=\"" + acceptablePaymentIds[acceptablePaymentId] + "\"]");
				paymentOption.removeClass("d-none");
			}
		}

		if ($(this).hasClass("packeta-open")) {
			showPacketaWidget();
		}
	});

	$(".payment-option").off("click").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

		$(".payment-option").removeClass("selected");
		$(this).addClass("selected");
		$(this).find("input").prop("checked", true);
	});

	$.nette.ext("add-to-cart-form", {
		success: function () {
			initAddToCartForm();
		}
	});
});

function showSelectedPickupPoint(point) {
	if (point) {
		const name = point.name + " (" + point.place + ")";
		const id = point.id;

		$(".packeta-branch-name").html(name);
		$("input[name=\"vm_name\"]").val(name);
		$("input[name=\"vm_code\"]").val(id);
	}
}

function showPacketaWidget()
{
	const packetaApiKey = "a6d31e9802903ad2";
	Packeta.Widget.pick(packetaApiKey, showSelectedPickupPoint, {country: "cz", language: "cs"});
}

function initAddToCartForm() {
	$(".add-to-cart-plus").off("click").on("click", function (e) {
		const inputElem = $(this).parents("form").find("input[name='count']");
		const currentVal = parseInt(inputElem.val());

		console.log(inputElem);

		if (currentVal < inputElem.attr("max")) {
			inputElem.val(currentVal + 1);
		}

		e.preventDefault();
		e.stopPropagation();
	});

	$(".add-to-cart-minus").off("click").on("click", function (e) {
		const inputElem = $(this).parents("form").find("input[name='count']");
		const currentVal = parseInt(inputElem.val());

		if (currentVal > inputElem.attr("min")) {
			inputElem.val(currentVal - 1);
		}

		e.preventDefault();
		e.stopPropagation();
	});
}
